(() => {
  if (!['127.0.0.1', 'localhost', '[::1]'].includes(location.hostname)) return;
  if (new URLSearchParams(location.search).get('preview_cart') !== '1') return;
  function openPreview() {
    const drawer = document.getElementById('halo-cart-sidebar');
    const trigger = document.querySelector('[data-cart-sidebar]');
    if (!drawer || !trigger) return;
    trigger.click();
    document.body.classList.add('cart-sidebar-show');
    drawer.querySelector('[data-close-cart-sidebar]')?.focus({ preventScroll: true });
  }
  if (document.readyState === 'complete') openPreview();
  else window.addEventListener('load', openPreview, { once: true });
})();
